export const normalizeSubject = (
  canvasSubject?: string | null,
  extractedPromptSubject?: string | null,
): string | null => {
  const clean = (value?: string | null): string | null => {
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    return trimmed.length ? trimmed : null;
  };

  return clean(canvasSubject) || clean(extractedPromptSubject) || null;
};

export const normalizeSubjectLabel = (
  canvasSubject?: string | null,
  extractedPromptSubject?: string | null,
): string => normalizeSubject(canvasSubject, extractedPromptSubject) || 'unknown';
